module.exports = __webpack_public_path__ + "img/quick_03.fdf8c99b.png";